import { TemplateStage4Form } from './TemplateStage4Form';

export default TemplateStage4Form;